import { startCase } from "lodash";
import { AddonFieldResponse, Field, FieldResponse, FieldType } from "types";

export const defaultField: Field = {
    id: "name_field_id",
    label: "Name",
    organizerOnly: false,
    required: true,
    roster: false,
    addToSavedViews: false,
    type: FieldType.TEXT,
    readonly: true,
};

export const isAddonFieldResponse = (fieldResponse: FieldResponse): fieldResponse is AddonFieldResponse => {
    return fieldResponse.type === FieldType.ADDON;
};

const normalize = (s: string) => s.replace(/-/g, " ").toLowerCase().trim();

export const valueFromSku = (sku: string, label: string): string | null => {
    if (!sku || !label) return null;

    const fieldName = normalize(label);
    const skuName = normalize(sku);
    if (fieldName && skuName && fieldName !== skuName && skuName.startsWith(fieldName)) {
        return startCase(skuName.slice(fieldName.length).trim());
    }
    return null;
};

export const formatFieldLabel = (field: FieldResponse): string => {
    if (isAddonFieldResponse(field)) {
        const value = valueFromSku(field.sku, field.label);
        if (value) {
            return `${field.label} : ${value}`;
        }
    }
    return field.label;
};
